import React from "react";

/** Цепочка закрытия прошла БЕЗ передачи между организациями: продажу целиком
 *  покрыл остаток юрлица в комнате ФБС (план цепочки, `fbs/seller_stock.py`).
 *
 *  Без пояснения список «заказ + расходная» выглядит недоделанной цепочкой —
 *  человек пошёл бы искать пропавшие ПТМО и счёт-фактуру. Флаг считает СЕРВЕР
 *  (`ptmo_skipped`), экран его только показывает. Общий у ВБ и Ozon: цепочка
 *  у них одна. */
export function PtmoSkippedNote({ skipped }: { skipped: boolean }): React.ReactElement | null {
  if (!skipped) return null;
  return (
    <p className="rounded border border-emerald-300 bg-emerald-50 p-2 text-sm text-emerald-800">
      Передача между организациями не нужна — покрыто остатком юрлица
    </p>
  );
}
